import { DELETE_TENANT, DESELECT_ALL_TENANT_IDS, DESELECT_TENANT_ID, DISABLE_TENANT, ENABLE_TENANT, SELECT_ALL_TENANT_IDS, SELECT_TENANT_ID, SET_ERROR, SET_LOADING, SET_PROJECT, SET_TENANT_ID, SET_TENANTS, TOGGLE_DELETE_APP_DIALOG, TOGGLE_DISABLE_APP_DIALOG, TOGGLE_SYNC_ALL_TENANTS_DIALOG, TOGGLE_SYNC_TENANT_DIALOG, UPDATE_ALL_TENANTS, UPDATE_PROJECT, UPDATE_TENANT_BY_TENANT_ID } from "./TenantsAppEvents";

export const initialTenantsAppState = {
    tenants: [],
    project: {},
    selectedTenantIds: [],
    loading: true,
    selectedTenantId: null,
    showDeleteAppDialog: false,
    showDisableAppDialog: false,
    showSycnAllTenantsDialog: false,
    showSyncTenantDialog: false,
    errorMessage: null,
};

export const TenantsAppReducer = (state, action) => {
    switch (action.type) {
        case SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case SET_PROJECT:
            return {
                ...state,
                project: action.payload
            };
        case UPDATE_PROJECT:
            return {
                ...state,
                project: {
                    ...state.project,
                    ...action.payload
                }
            };
        case SET_TENANTS:
            return {
                ...state,
                tenants: action.payload
            };
        case DELETE_TENANT:
            return {
                ...state,
                tenants: state.tenants.filter(tenant => tenant._id !== action.payload)
            };
        case DISABLE_TENANT:
            return {
                ...state,
                tenants: state.tenants.map(tenant => {
                    if (tenant._id === action.payload.tenantId) {
                        return {
                            ...tenant,
                            project: {
                                ...tenant.project,
                                status: "disabled",
                                tenantProject: {
                                    ...tenant.project.tenantProject,
                                    isActive: false
                                }
                            }
                        };
                    }
                    return tenant;
                })
            };
        case ENABLE_TENANT:
            return {
                ...state,
                tenants: state.tenants.map(tenant => {
                    if (tenant._id === action.payload.tenantId) {
                        return {
                            ...tenant,
                            project: {
                                ...tenant.project,
                                status: "accepted",
                                tenantProject: {
                                    ...tenant.project.tenantProject,
                                    isActive: true
                                }
                            }
                        };
                    }
                    return tenant;
                })
            };
        case SET_TENANT_ID:
            return {
                ...state,
                selectedTenantId: action.payload
            };
        case SELECT_ALL_TENANT_IDS:
            return {
                ...state,
                selectedTenantIds: state.tenants.map(tenant => tenant._id)
            };
        case DESELECT_ALL_TENANT_IDS:
            return {
                ...state,
                selectedTenantIds: []
            };
        case SELECT_TENANT_ID:
            return {
                ...state,
                selectedTenantIds: [...state.selectedTenantIds, action.payload]
            }
        case DESELECT_TENANT_ID:
            return {
                ...state,
                selectedTenantIds: state.selectedTenantIds.filter(id => id !== action.payload)
            }
        case TOGGLE_DELETE_APP_DIALOG:
            return {
                ...state,
                showDeleteAppDialog: !state.showDeleteAppDialog
            };
        case TOGGLE_DISABLE_APP_DIALOG:
            return {
                ...state,
                showDisableAppDialog: !state.showDisableAppDialog
            };
        case TOGGLE_SYNC_ALL_TENANTS_DIALOG:
            return {
                ...state,
                showSycnAllTenantsDialog: !state.showSycnAllTenantsDialog
            };
        case TOGGLE_SYNC_TENANT_DIALOG:
            return {
                ...state,
                showSyncTenantDialog: !state.showSyncTenantDialog
            };
        case UPDATE_ALL_TENANTS:
            return {
                ...state,
                tenants: state.tenants.map(tenant => {
                    return {
                        ...tenant,
                        ...action.payload
                    };
                })
            };
        case UPDATE_TENANT_BY_TENANT_ID:
            return {
                ...state,
                tenants: state.tenants.map(tenant => {
                    if (tenant._id === action.payload.tenantId) {
                        return {
                            ...tenant,
                            ...action.payload.data
                        };
                    }
                    return tenant;
                })
            };
        case SET_ERROR:
            return {
                ...state,
                errorMessage: action.payload
            };
        default:
            return state;
    }
}